function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import KPIs from './KPIs';
import styles from './Header.pcss';
var _React_Component;
class Summary extends (_React_Component = React.Component) {
    render() {
        const { phiSet, readingsWithRelatedData, standards, conversion, weekNumber, startDayTimestamp, translatedTimeSeriesResources } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.dailyLogReport__summary,
            children: /*#__PURE__*/ _jsx(KPIs, {
                phiSet: phiSet,
                readingsWithRelatedData: readingsWithRelatedData,
                standards: standards,
                conversion: conversion,
                weekNumber: weekNumber,
                startDayTimestamp: startDayTimestamp,
                translatedTimeSeriesResources: translatedTimeSeriesResources
            })
        });
    }
}
_define_property(Summary, "propTypes", {
    // Explicit props
    weekNumber: PropTypes.number.isRequired,
    startDayTimestamp: PropTypes.string.isRequired,
    phiSet: PropTypes.object.isRequired,
    conversion: PropTypes.object.isRequired,
    translatedTimeSeriesResources: PropTypes.array.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    readingsWithRelatedData: PropTypes.array
});
export default withStyles(styles)(Summary);
